import * as React from 'react';
import Menu from '@mui/material/Menu';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import NavList from './NavList';
import Link from 'next/link';
import { FeatureButtons } from '../UserButtons';

type MobileMenuProps = {
  menu: Menu | null;
  isAuthenticated: boolean;
  isProfessionalMember: boolean;
};

export default function MobileMenu({
  menu,
  isAuthenticated,
  isProfessionalMember
}: MobileMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`mobile-nav nav-menu${open ? '__open' : ''}`}>
      <a
        id='menu-button'
        href={`#nav-menu-mobile`}
        aria-controls={open ? 'mobile-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        className='nav-link'
        onClick={(event) => handleClick(event)}
      >
        <div className='nav-link__text'>
          Menu
          <span className='nav-link__expand-icon'>
            <KeyboardArrowDown />
          </span>
        </div>
      </a>
      <Menu
        id='mobile-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        hideBackdrop={false}
        marginThreshold={0}
        MenuListProps={{
          'aria-labelledby': 'menu-button'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        // anchorPosition={{
        //   top: rect ? rect.bottom : 0,
        //   left: 0,
        // }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        slotProps={{
          paper: {
            sx: {
              width: '100vw',
              maxWidth: '100vw'
            }
          }
        }}
        sx={{
          width: '100vw',
          maxWidth: '100vw',
          marginTop: '1px'
        }}
      >
        {menu &&
          NavList.map((nav) => {
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            const hasFieldOrChild = nav.field || nav.child || nav.fields;

            if (hasFieldOrChild) {
              const menuKey = nav.field as MenuKey;
              const menuKeys = nav.fields as unknown as MenuKey[];
              const child = nav.child;
              return (
                <Accordion
                  elevation={0}
                  sx={{
                    padding: 0,
                    margin: 0,
                    gap: 0
                  }}
                  key={nav.name}
                >
                  <AccordionSummary
                    expandIcon={<KeyboardArrowDown className='menu-toggle' />}
                    aria-controls='panel1-content'
                    id='panel1-header'
                    sx={{
                      padding: 0,
                      margin: 0
                    }}
                  >
                    {nav.name}
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      padding: 0,
                      margin: 0
                    }}
                  >
                    {child &&
                      child.length > 0 &&
                      child.map((childLink) => (
                        <div key={childLink.name}>
                          <Link
                            prefetch={false}
                            href={childLink.link}
                            className='nav-child-link'
                            onClick={handleClose}
                          >
                            <div className='nav-link__text'>
                              {childLink.name}
                            </div>
                          </Link>
                        </div>
                      ))}
                    {menuKey &&
                      menu[menuKey].map((menuItem) => (
                        <div key={menuItem?.name ?? 'key'}>
                          <Link
                            prefetch={false}
                            href={menuItem?.slug ?? '#'}
                            className='nav-child-link'
                            onClick={handleClose}
                          >
                            <div className='nav-link__text'>
                              {menuItem?.name ?? ''}
                            </div>
                          </Link>
                        </div>
                      ))}
                    {menuKeys?.map((key) => (
                      <div key={key} className='sub-section'>
                        {menu[key].map((menuItem) => (
                          <Link
                            prefetch={false}
                            href={menuItem?.slug ?? '#'}
                            className='nav-child-link'
                            key={menuItem.slug ?? 'child'}
                            onClick={handleClose}
                          >
                            <div className='nav-link__text'>
                              {menuItem?.name ?? ''}
                            </div>
                          </Link>
                        ))}
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
              );
            }
            return (
              <Link
                prefetch={false}
                key={nav.name}
                href='#'
                className='nav-link'
              >
                <div className='nav-link__text'>
                  {nav.name}
                  <div className='nav-link__underline' />
                </div>
              </Link>
            );
          })}
        <div className={`user-btn-group`}>
          <FeatureButtons onClick={handleClose} />
        </div>
      </Menu>
    </div>
  );
}
